// extracted by mini-css-extract-plugin
module.exports = {"header__waffle-menu-title":"HeaderWaffleMenuTitle_header__waffle-menu-title__fuEa9"};